<template>
  <ModalJob class="modal-job" v-if="getModalType === 'job' && getIsShowing === true" />
  <div class="footer">
    <div id="bb-job-number" class="bottom-bar" @click="handleJobInput">Enter Job Data</div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import ModalJob from '@/modal/ModalJob.vue';
import { useInputStore } from '@/store/InputStore';

export default {
  computed: {
    getJobNumber () {
      return useInputStore().getJobNumber;
    },
    getModalType () {
      return useModalStore().getModalType;
    },
    getIsShowing () {
      return useModalStore().getIsShowing;
    }
  },
  methods: {
    handleJobInput () {
      useModalStore().showModal('job');
    }
  },
  components: {
    ModalJob
  }
};
</script>

<style scoped>
.modal-job {
  z-index: 9999;
  bottom: 0px;
  position: absolute;
}
.bottom-bar {
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  padding-left: 10px;
  font-weight: 600;
  padding-top: 2px;
  padding-bottom: 2px;

}

.footer {
  width: 100%;
  border-top: 1px solid lightgray;
}

</style>
